import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TripService } from '../services/trip.service';
import { isParticipantPaymentAllowed } from '../services/payment/build-participant-payment-access';

export const paymentGuard: CanActivateFn = () => {
  const tripService = inject(TripService);
  const router = inject(Router);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  const allowed = isParticipantPaymentAllowed(trip, tripService.hasEnded());

  return allowed ? true : router.createUrlTree(['/dashboard']);
};
